module.exports = __webpack_public_path__ + "img/donante-jump-in.4aea9e3b.png";